import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ["select"]

  showSelect() {
    this.selectTarget.classList.remove("hidden");
  }
}